"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assign;

function assign(obj, source) {
  // This rule is necessary for this function to work

  /* eslint no-param-reassign: 0 */
  if (source) {
    Object.keys(source).forEach(function (name) {
      obj[name] = source[name];
    });
  }

  for (var _len = arguments.length, sources = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    sources[_key - 2] = arguments[_key];
  }

  return sources.length === 0 ? obj : assign.apply(undefined, [obj].concat(sources));
}